import {AfterViewInit, Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgxSpinnerService} from "ngx-spinner";
import {DialogComponentsModule} from "../../components/dialogs/dialog-components.module";
import {
   AbstractControl,
   FormsModule,
   ReactiveFormsModule,
   UntypedFormControl,
   UntypedFormGroup,
   Validators
} from "@angular/forms";
import {HeaderTopModule} from "../../components/standalone/header-top/header-top.module";
import {MatButtonModule} from "@angular/material/button";
import {MatDatepickerInputEvent, MatDatepickerModule} from "@angular/material/datepicker";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatOptionModule} from "@angular/material/core";
import {MatRadioModule} from "@angular/material/radio";
import {MatSelectModule} from "@angular/material/select";
import {MaterialFileInputModule} from "ngx-material-file-input";
import {Sesso} from "../../models/UserProfile";
import {Stato} from "../../models/Stato";
import {Regione} from "../../models/Regione";
import {PopupGenericComponent} from "../../components/dialogs/popup-generic/popup-generic.component";
import {DialogService} from "../../components/generics/dialog/dialog.service";
import {ServerService} from "../../services/server.service";
import * as _ from "lodash";
import {Moment} from "moment/moment";
import {Esercizio} from 'src/app/models/Esercizio';
import {MatCheckboxModule} from "@angular/material/checkbox";

@Component({
   selector: 'app-fast-register',
   standalone: true,
   imports: [CommonModule, DialogComponentsModule, FormsModule, HeaderTopModule, MatButtonModule, MatDatepickerModule, MatFormFieldModule, MatIconModule, MatInputModule, MatOptionModule, MatRadioModule, MatSelectModule, MaterialFileInputModule, ReactiveFormsModule, MatCheckboxModule],
   templateUrl: './fast-register.component.html',
   styleUrls: ['./fast-register.component.scss']
})
export class FastRegisterComponent implements OnInit, AfterViewInit {
   public Esercizio = Esercizio
   public hidepw = true;
   public hidepw2 = true;
   public frmGrpUser: UntypedFormGroup = new UntypedFormGroup({});
   public sesso = Sesso;
   public flags = [
      {value: "+39", flag:"🇮🇹"}
   ]

   arrStati:Stato[] = []
   arrRegioni:Regione[] = []
   termsConditions = {terms:''}
   termsConditionsAccepted:boolean = false
   popupTermsVisible: boolean = false;

   popupTermsButtons:any = [
      {
         text: 'Accetta Termini e Condizioni di Utilizzo', key:'ok', onClick: (popup: PopupGenericComponent)=>{
            this.termsConditionsAccepted = true
            popup.close()
         }
      }
   ];

   constructor(private spinner: NgxSpinnerService,
               private dialogSrv: DialogService,
               private serverSrv: ServerService) {
      this.initForm()
   }

   ngOnInit(): void {
   }

   async ngAfterViewInit() {
      this.fetchTermsConds()
      await this.spinner.hide();
   }

   initForm(){
      this.frmGrpUser = new UntypedFormGroup({
         first_name: new UntypedFormControl('', Validators.required),
         last_name: new UntypedFormControl('', Validators.required),
         email: new UntypedFormControl('', [Validators.required, Validators.email]),
         confirm_email: new UntypedFormControl('', [Validators.required, Validators.email]),
         password: new UntypedFormControl('', Validators.required),
         confirm_password: new UntypedFormControl('', Validators.required),
         profile: new UntypedFormGroup({
            data_nascita: new UntypedFormControl('', Validators.required),
            cellulare: new UntypedFormControl('', Validators.required),
            cellulare_prefix: new UntypedFormControl('+39', Validators.required),
            codice_fiscale: new UntypedFormControl('', Validators.required)
         }),

         esercizio: new UntypedFormGroup({
            display_name: new UntypedFormControl('', Validators.required),
            ragione_sociale: new UntypedFormControl('', Validators.required),
            piva: new UntypedFormControl('', Validators.required),
         }),
      }, { validators: [this.checkPasswords, this.checkEmails]});
   }

   fetchTermsConds(){
      this.serverSrv.get(null, `/api/termini_condizioni`).then(res => {
         this.termsConditions = res
         console.log(this.termsConditions)
      }).catch(err => {
         console.error(err)
      })
   }

   public clickVisibility($e: any) {
      $e.preventDefault();
      this.hidepw = !this.hidepw;
   }

   public clickVisibility2($e: any){
      $e.preventDefault();
      this.hidepw2 = !this.hidepw2;
   }

   checkPasswords(control: AbstractControl) {
      const password = control.get('password');
      const confirm_password = control.get('confirm_password');

      let has_err = password && confirm_password && password.value !== confirm_password.value ? { not_same_pswd: true } : null;
      if (has_err) confirm_password?.setErrors({not_same_pswd: true});
      else confirm_password?.setErrors(null);

      return has_err;
   };

   checkEmails(control: AbstractControl) {
      const email = control.get('email');
      const confirm_email = control.get('confirm_email');

      let has_err = email && confirm_email && email.value !== confirm_email.value ? { not_same_email: true } : null;
      if (has_err) confirm_email?.setErrors({not_same_email: true});
      else confirm_email?.setErrors(null);

      return has_err;
   };

   public onSubmit() {
      this.dialogSrv.showConfirm({msg: "Procedere alla registrazione dei dati inseriti?", title: "Conferma operazione"})
         .then(async () => {
            await this.spinner.show();
            let data = _.cloneDeep(this.frmGrpUser.value);

            // let data_str = JSON.stringify(data)

            this.serverSrv.post('/auth/register?fast_register=1', data)
               .then(() => {
                  this.spinner.hide();
                  this.dialogSrv.showSuccess({msg: "Registrazione avvenuta correttamente!"})
                     .then(() => {
                        // window.location.href = environment.loginPath
                        window.location.href = "/app/web/view/welcome"
                     });
               })
               .catch(err => {
                  this.spinner.hide();
                  this.dialogSrv.closeAll()

                  this.dialogSrv.showError({msg: "Errore registrazione", err: err})
               });

         }).catch((err) => {
         console.error(err)
      });
   }

   onDataNascitaChange(eName: string, $event: MatDatepickerInputEvent<unknown, unknown | null>) {
      if($event.value){
         let m: Moment = $event.value as Moment
         // this.frmGrpUser.patchValue({key:m.format("YYYY-MM-DD")}, "profile__data_nascita")
         this.frmGrpUser.patchValue({profile:{data_nascita: m.format("YYYY-MM-DD")}})
      }
   }

   clickConferma($e) {
      console.log(this.frmGrpUser)
      if(!this.frmGrpUser.valid){
         this.frmGrpUser.markAllAsTouched()
         this.dialogSrv.showToastError({msg:"Compila tutti i campi!"})
         $e.preventDefault()
         return
      }else{
         this.onSubmit();
      }
   }

   patchNomeEsercizio() {
      this.frmGrpUser.get('esercizio')?.get('display_name')?.patchValue(this.frmGrpUser.get('esercizio')?.get('ragione_sociale')?.value)
   }

   clickApriTermsConds() {
      this.popupTermsVisible = true
   }

}
